import { SVGProps } from "react";
const CreatePostSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 13.067v5.905A2.02 2.02 0 0 1 18.987 21H5.013A2.02 2.02 0 0 1 3 18.972V6.028A2.02 2.02 0 0 1 5.013 4H12"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m7.828 17.172 3.731-.933c.176-.044.336-.135.465-.263l8.39-8.39a2 2 0 0 0 0-2.828l-.172-.172a2 2 0 0 0-2.828 0l-8.39 8.39a1.001 1.001 0 0 0-.263.465l-.933 3.731M15.832 6.17l3 3"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.547 16.242c.014-.106.032-.211.032-.321a2.5 2.5 0 0 0-2.5-2.5c-.11 0-.215.019-.321.032"
    />
  </svg>
);
export default CreatePostSvg;
